import {AppointmentDto} from "@/types/appointments";
import {format} from "date-fns";

export function getRowColor(appointment: AppointmentDto): string {
    if (appointment.status == "CANCELLED") {
        return "#d4d7d9"
    }
    if (format(new Date(), "yyyy-MM-dd").localeCompare(appointment.appointmentDate) === 0 &&
        format(new Date(), "HH:mm").localeCompare(appointment.slot) >= 0 &&
        format(new Date(), "HH:mm").localeCompare(appointment.endTime) <= 0)
    {
        return "#f5bcbc"
    }
    if (appointment.appointmentDate.localeCompare(format(new Date(), "yyyy-MM-dd")) >= 0 ) {
        return "#d0f2d1"
    }
    if (appointment.appointmentDate.localeCompare(format(new Date(), "yyyy-MM-dd")) <= 0) {
        return "#d4d7d9"
    }
}

export function getPaymentStatusColor(paymentStatus: string): string {
    if (paymentStatus === "PAYMENT_REQUESTED") return '#faf5b6';
    if (paymentStatus === "PAID") return '#a8f0bf';
    if (paymentStatus === "REFUNDED") return '#fac0ee';
    if (paymentStatus === "CANCELLED") return '#fa7077';
    if (paymentStatus === "FAILED") return '#fa7077';
    if (paymentStatus === "FREE") return '#b1d9fa';
    if (paymentStatus === "UNKNOWN") return '#a0a2a3';
}

export function getAppointmentStatusColor(appointmentStatus: string): string {
    if (appointmentStatus === "REQUESTED") return '#faf5b6';
    if (appointmentStatus === "SCHEDULED") return '#faf5b6';
    if (appointmentStatus === "RESCHEDULED") return '#faf5b6';
    if (appointmentStatus === "COMPLETED") return '#a8f0bf';
    if (appointmentStatus === "MISSED") return '#fa7077';
    if (appointmentStatus === "CANCELLED") return '#fa7077';
}
